import Flickity from 'flickity';
import 'flickity-imagesloaded';

const settings = {
  imagesLoaded: true,
  percentPosition: false,
  wrapAround: true,
  cellAlign: 'center',
  pageDots: false,
  prevNextButtons: false,
  watchCSS: true,
  cellSelector: '.js-slide',
};

document.querySelectorAll('.js-carousel').forEach((el) => {
  const flkty = new Flickity(el, settings);

  flkty.once('select', () => el.classList.add('is-active'));

  const prev = el.querySelector('.js-prev');
  const next = el.querySelector('.js-next');
  if (prev) prev.addEventListener('click', () => flkty.previous(settings.wrapAround));
  if (next) next.addEventListener('click', () => flkty.next(settings.wrapAround));
});
